import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackProductRemovedFromQuickOrderParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackProductRemovedFromQuickOrder";

const useTrackProductRemovedFromQuickOrder = (
    parameters: TrackProductRemovedFromQuickOrderParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.productRemovedFromQuickOrder, parameters, options);
};

export default useTrackProductRemovedFromQuickOrder;
